import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MenuItem, Select } from '@material-ui/core';

import { toggleSwitch } from '../../../actions/index';
import { _ } from '../../../functions/translator.js';

import ZonesDropdown from './zonesDropdown.js';
import FormDropdown from './formDropdown.js';
import VolumeDropdown from './volumeDropdown.js';
import AreaDropdown from './areaDropdown.js';
import SurfaceDropdown from './surfaceDropdown.js';
import HeightDropdown from './heightDropdown.js';
import BimElementDropdown from './bimElementDropdown.js';
import UserDropdown from '../userDropdown.js';
import { attributeHasValueinElementsData, objectIsNotEmpty } from '../../../functions/utils.js';

class ExtraFilters extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            filtersAdded: [],
            filters: {
                user: {
                    name: _('Encargados'),
                    component: <UserDropdown closeCallback={this.handleCloseFilter}/>,
                    hasValues: objectIsNotEmpty(this.props.projectUsers),
                },
                zones: {
                    name: _('Ciclos'),
                    component: <ZonesDropdown closeCallback={this.handleCloseFilter}/>,
                    hasValues: objectIsNotEmpty(this.props.projectData.zones),
                },
                customcards: {
                    name: _('Formularios'),
                    component: <FormDropdown closeCallback={this.handleCloseFilter}/>,
                    hasValues: objectIsNotEmpty(this.props.projectData.customcards),
                },
                volume: {
                    name: _('Volumen'),
                    component: <VolumeDropdown closeCallback={this.handleCloseFilter}/>,
                    hasValues: attributeHasValueinElementsData(this.props.projectData.figures, 'real_volume'),
                },
                area: {
                    name: _('Área'),
                    component: <AreaDropdown closeCallback={this.handleCloseFilter}/>,
                    hasValues: attributeHasValueinElementsData(this.props.projectData.figures, 'real_area'),
                },
                surface: {
                    name: _('Superficie'),
                    component: <SurfaceDropdown closeCallback={this.handleCloseFilter}/>,
                    hasValues: attributeHasValueinElementsData(this.props.projectData.figures, 'real_surface'),
                },
                height: {
                    name: _('Altura'),
                    component: <HeightDropdown closeCallback={this.handleCloseFilter}/>,
                    hasValues: attributeHasValueinElementsData(this.props.projectData.figures, 'top_height'),
                },
                bim_element: {
                    name: _('Elemento BIM'),
                    component: <BimElementDropdown closeCallback={this.handleCloseFilter}/>,
                    hasValues: attributeHasValueinElementsData(this.props.projectData.figures, 'bim_description'),
                },
            },
            isFilterAdded: true,
        }
    }

    handleFilterChange = (event) => {
        const filterKey = event.target.value;
        const filtersAdded = [...this.state.filtersAdded];
        if (!filtersAdded.includes(filterKey)) {
            filtersAdded.push(filterKey);
        }
        this.setState({ isFilterAdded: true });
        this.setState({ filtersAdded: filtersAdded });
    }

    handleCloseFilter = (event) => {
        const filterKey = event.target.dataset.type;
        const filtersAdded = this.state.filtersAdded.filter(key => key !== filterKey);
        this.setState({ isFilterAdded: false });
        this.setState({ filtersAdded: filtersAdded });
    }

    getFilterslist = () => {
        const filtersList = [];
        for (const [filterKey, filter] of Object.entries(this.state.filters)) {
            if (this.state.filtersAdded.includes(filterKey)) continue;
            if (!filter.hasValues) continue;
            filtersList.push(
                <MenuItem value={filterKey} key={filterKey}>
                    {filter.name}
                </MenuItem>
            );
        }
        return filtersList;
    }

    getExtraFilters = () => {
        const extraFilters = [];
        for (let i = 0; i < this.state.filtersAdded.length; i++) {
            const filterKey = this.state.filtersAdded[i];
            const isLastFilter = i === this.state.filtersAdded.length - 1;
            const component = this.state.filters[filterKey].component;
            const focusClass = this.state.isFilterAdded && isLastFilter ? 'filter-focus' : '';
            component.props.extraClass = focusClass;
            extraFilters.push(component);
        }
        return extraFilters;
    }

    render() {
        const filtersList = this.getFilterslist();
        const extraFilters = this.getExtraFilters(); 
        return(
            <div>
                {extraFilters}
                { filtersList.length ? (
                    <div className='rounded bg-secondary-gray px-2 pb-2 mt-4'>
                        <p className='text'>+ {_('Agregar Filtro')}</p>
                            <Select
                                value={null}
                                onChange={this.handleFilterChange}>
                                {filtersList}
                            </Select>
                    </div>
                ) : null
                }
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return { 
        projectData  : state.projectData,
        projectUsers : state.projectUsers,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch : toggleSwitch,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(ExtraFilters);